import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { OneBtnModal } from "components/common/modal";
import { TableSearchInput } from "components/common/input";
import { PrimaryBtn } from "components/common/button";
import { ParkConsultingListTable } from "components/parkConsulting";
import { PrimayPagination } from "components/common/pagination";
import { postParkConsultingComplete } from "service/api/apply";
import type { IParkConsultingList } from "service/interface/apply";
import responseCodeConstant from "service/constant/responseCodeConstant";

export function ParkConsultingListPage() {
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectPage, setSelectPage] = useState<number>(1);
  const [selectTable, setSelectTable] = useState<number[]>([]);
  const [listData, setListData] = useState<{
    count: number;
    data: IParkConsultingList[];
  }>({ count: 0, data: [] });
  const [isCompleteSuccessModalVisible, setIsCompleteSuccessModalVisible] =
    useState<boolean>(false);

  const { data, mutate } = useSWR(
    `/admin/manage/parkconsulting?limit=12&offset=${
      selectPage * 12 - 12
    }&search=${searchValue}`,
  );

  useEffect(() => {
    if (data) {
      setListData(data);
    }
  }, [data]);

  const handlePageMove = () => {
    setSelectTable([]);
  };

  const handleCheckCompleteBtn = async () => {
    const completeRes = await postParkConsultingComplete(selectTable);
    if (completeRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsCompleteSuccessModalVisible(true);
    }
  };

  const handleSuccessModalBtn = () => {
    setSelectTable([]);
    mutate();
  };

  return (
    <>
      <OneBtnModal
        isVisible={isCompleteSuccessModalVisible}
        setIsVisible={setIsCompleteSuccessModalVisible}
        title="처리 완료"
        subTitle="일괄 처리가 완료 되었습니다."
        btnLabel="확인"
        btnClick={handleSuccessModalBtn}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_55px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
            추모공원 신청 정보
          </p>
          <div className="mb-[24px] mt-[16px] flex items-center justify-between">
            <TableSearchInput
              value={searchValue}
              setValue={setSearchValue}
              placeholder="이름, 휴대폰 번호, 공원명으로 검색해 보세요."
            />
            <PrimaryBtn
              color="white"
              isDisabled={selectTable.length === 0}
              label="일괄 처리"
              onClick={handleCheckCompleteBtn}
            />
          </div>
          <ParkConsultingListTable
            data={listData.data}
            selectTable={selectTable}
            setSelectTable={setSelectTable}
          />
          <div className="mt-[32px] flex items-center justify-end">
            <PrimayPagination
              listLength={Math.ceil(listData.count / 12)}
              pageNumber={selectPage}
              setPageNumber={setSelectPage}
              onChange={handlePageMove}
            />
          </div>
        </div>
      </div>
    </>
  );
}
